var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRetry = function SvgIconRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.383 7.181 2.5 6.517A8.193 8.193 0 1 0 10.113.33a.75.75 0 1 0 .062 1.499 6.693 6.693 0 1 1-6.181 4.909l.702 1.427a.75.75 0 0 0 1.346-.662l-1.84-3.742-3.586 2.13a.75.75 0 1 0 .767 1.29Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.928 3.967a.75.75 0 0 0-1.5 0v5.75h4.75a.75.75 0 0 0 0-1.5h-3.25v-4.25Z",
    fill: "currentColor"
  })));
};
export default SvgIconRetry;